import { GET_AGENT, AGENT_RECEIVED } from './constants';

export const getAgent = code => ({
  type: GET_AGENT,
  code,
});

export function agentLoaded(agent) {
  return {
    type: AGENT_RECEIVED,
    agent,
  };
}
